import { Routes, Route } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import DashboardRoutes from "./DashboardRoutes";
import ProtectedRoute from "../components/ProtectedRoute";
import GlobalSocketListeners from "../components/GlobalSocketListeners";

function PrivateRoutes() {
    return (
        <ProtectedRoute>
            <DashboardLayout>
                <GlobalSocketListeners />
                <Routes>
                    <Route path="/*" element={<DashboardRoutes />} />
                </Routes>
            </DashboardLayout>
        </ProtectedRoute>
    );
}

export default PrivateRoutes;